import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { MijnRouteKey, MijnRoutes } from '@ap/mijn-navigatie';

@Injectable({ providedIn: 'root' })
export class PendingProductionGuard {
    constructor(private readonly router: Router) {}

    public canActivate(): boolean | UrlTree {
        if (!this.isPendingProduction()) {
            return this.router.parseUrl(MijnRoutes.get(MijnRouteKey.PAGE_NOT_FOUND).path);
        }
        return true;
    }

    private isPendingProduction(): boolean {
        try {
            return JSON.parse('{<IS_PENDING_PRODUCTION>}');
        } catch (e) {
            return true;
        }
    }
}
